import { Component, inject, OnInit } from '@angular/core';
import { AppInformationService } from 'app/core/app-information.service';
import { InvoiceService } from 'app/core/invoice.service';
import { SessionInformationService } from 'app/core/session-information.service';
import _ from 'lodash';
import moment from 'moment';

@Component({
    standalone: false,
    selector: 'app-tax-code-summary-report',
    templateUrl: './tax-code-summary-report.component.html',
    styleUrl: './tax-code-summary-report.component.scss',
})
export class TaxCodeSummaryReportComponent implements OnInit {
    invoiceService = inject(InvoiceService);
    sessionInfo = inject(SessionInformationService);
    appInfo = inject(AppInformationService);

    filter: { startDate?: Date; endDate?: Date };
    summaries: { taxable: any[]; nonTaxable: any[] };
    totals: { taxable: { today: number; total: number }; nonTaxable: { today: number; total: number }; total: { today: number; total: number } };
    invoiceSummaries: any;
    invoiceLineSummaries: any;

    async ngOnInit() {
        const filter = this.sessionInfo.getItem('tax-code-summary-filter');
        if (!filter) this.clear();
        else this.filter = filter;
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        const summaries = await this.invoiceService.getTaxCodeSummaries(this.filter);
        const invoiceSummaries = await this.invoiceService.getInvoiceSummaries(this.filter);
        this.invoiceSummaries = invoiceSummaries[0];
        const invoiceLineSummaries = await this.invoiceService.getInvoiceLineSummaries(this.filter);
        this.invoiceLineSummaries = invoiceLineSummaries[0];
        console.log('invoiceLineSummaries', this.invoiceLineSummaries);
        this.summaries = {
            taxable: summaries.filter((s) => s.isTaxable),
            nonTaxable: summaries.filter((s) => !s.isTaxable),
        };
        this.totals = {
            taxable: this.getTotals(this.summaries.taxable),
            nonTaxable: this.getTotals(this.summaries.nonTaxable),
            total: this.getTotals(summaries),
        };
        console.log('totals', this.totals);
        this.sessionInfo.setItem('tax-code-summary-filter', this.filter);
        this.appInfo.pleaseWaitHide();
    }

    getTotals(summaries: any[]) {
        return {
            today: _(summaries).sumBy((s) => s.todayTotal),
            total: _(summaries).sumBy((s) => s.total),
        };
    }

    clear() {
        const lastMonth = moment().subtract(1, 'months').startOf('month');

        this.filter = { 
            startDate: moment().subtract(1, 'months').startOf('month').toDate(), 
            endDate: moment().subtract(1, 'months').endOf('month').toDate() 
        };

        this.summaries = null;
        this.totals = null;
        this.sessionInfo.removeItem('tax-code-summary-filter');
    }
}
